<template>

    <div>
        <template v-if="method === 'bankgirot'">
            <div class="orange-payment-method-expanded">
                <div>
                    <div class="text-sm text-gray-400 mb-1 block">
                        När du klickar fortsätt kommer vi påbörja din leverans, samt maila dig instruktioner för betalning.
                    </div>
                </div>

                <div class="text-center mt-8 mb-2">
                    <card-button @click="pay" :loading="loading">
                        Fortsätt
                    </card-button>
                </div>
            </div>
        </template>
    </div>

</template>

<script>
    import axios from 'axios'
    import CardRadio from "./CardRadio";
    import CardInput from "./CardInput";
    import OrangePaymentStripePaymentIntent from "./OrangePaymentStripePaymentIntent";
    import CardButton from "./CardButton";

    export default {
        components: {CardButton, OrangePaymentStripePaymentIntent, CardRadio, CardInput},
        props: ['api', 'name', 'orderId', 'method'],
        data() {
            return {
                loading: false
            }
        },
        methods: {
            async pay() {
                this.loading = true
                await axios.post(`${this.api}/bankgirot/init`, { order_id: this.orderId })
                this.$emit('success')
            },
        }
    }
</script>

<style type="text/css">
    .orange-payment-method-expanded {
        padding-top: 22px;
        padding-left: 28px;
        padding-right: 28px;
    }
</style>